import React, { Component } from 'react';
import { Redirect } from 'react-router';
import './login.css';
import LoadMask from '../../Utils/LoadMask/LoadMask';
import LoginForm from './LoginForm';

class Login extends Component {
    render() {
        const { onSubmit, loader } = this.props;
        if (localStorage.getItem('token')) {
            const { me } = this.props;
            if (me.rol_usuario) {
                const initialView = me.rol_usuario.initial_view;
                return (<Redirect to={initialView} />);
            }
            return (<Redirect to="/" />);
        }
        return (
            <React.Fragment>
                <div className="bg-image"></div>
                
                {/* Badge en esquina superior derecha con estilo de franja */}
                <div className="project-badge">
                    <span className="project-badge__text">Presupuestos ERSA</span>
                </div>

                <section className="bg-content">
                    {/* Logo principal */}
                    <img src={require('assets/img/logo blanco.png')} alt="" className="mb-5 login-form__logo" />
                    
                    <div className="col-3 login-form__container">
                        <LoadMask loading={loader} light>
                            <LoginForm onSubmit={onSubmit} id="loginForm" />
                        </LoadMask>
                    </div>
                </section>

            </React.Fragment>
        )
    }
}

export default Login;
